<div class="container-fluid col-md-10">
  <form #workflowForm="ngForm">
    <section>
      <div class="card">
        <div class="card-header">Détail</div>
        <div class="card-body">
          <ng-container *ngTemplateOutlet="!canBeModified ? displayDetail : editDetail"></ng-container>
        </div>
      </div>

      <div class="card">
        <div class="card-header">Etapes du flux</div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="drag-list">
                <div class="row item-container drag-box" *ngFor="let workflowStage of workflowDetail.WorkflowStages">
                  <div class="col-xs-12 col-md-3 d-none d-md-block">
                    Niveau - <span class="">{{workflowStage.Level}}</span>
                  </div>
                  <div class="col-xs-11 col-md-8 px-0">
                    <div class="row">
                      <div class="col">
                        <ng-container *ngIf="(workflowStage.ValidationGroup != null && workflowStage.ValidationGroup.Id)">
                          {{workflowStage.ValidationGroup.Name}}
                        </ng-container>
                        <ng-container *ngIf="!workflowStage.IsOptional && (workflowStage.ValidationGroup != null && !workflowStage.ValidationGroup.Id)">
                          <ng-multiselect-dropdown name="stageGroup" [class]="'multiselect-dropdown-flux-' + workflowStage.Level" [settings]="groupDropDownSettings"
                            (onSelect)="onSelectGroup($event, workflowStage.ValidationGroup,'select', true)"
                            placeholder="Sélectionner" [data]="stageValidationGroups" required>
                          </ng-multiselect-dropdown>
                        </ng-container>
                      </div>
                      <div class="col-2" *ngIf="displayOptionalCondition && workflowStage.Level == 2">
                        <mat-slide-toggle [(ngModel)]="workflowStage.IsOptional" name="IsOptional-{{workflowStage.Level}}" [disabled]="isToggleOptional(workflowStage)">Facultative</mat-slide-toggle>
                      </div>
                      <div class="col-4 threshold-amount"
                        *ngIf="displayStageTriggerCondition && workflowStage.Level < maxWorkflowValidationStages && workflowStage.Level < currentMaxLevel">
                        <input type="number" name="ThresholdAmount-{{workflowStage.Level}}" [disabled]="!canBeModified"
                          [(ngModel)]="workflowStage.ThresholdAmount" />
                      </div>
                    </div>
                  </div>
                  <div class="col-1">
                    <span class="material-icons" (click)="removeStage(workflowStage)" *ngIf="canBeModified">
                      delete_forever
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="displayStageAddButton">
            <div class="col item-container item-container-new d-flex justify-content-center align-items-center">
              <span class="material-icons" (click)="addStage()" tooltip="Ajouter un niveau de validation">
                add_circle
              </span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!isValidationStageValid">
          <div class="col threshold-amount-error">
            {{stageValidations}}
          </div>
        </div>
      </div>

      <div class="card" *ngIf="displayComptabilitySection">
        <div class="card-header">Comptabilité</div>
        <div class="card-body">

          <div class="form-group-container form-group mx-0 row">
            <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label" for="name">Groupe en charge de la
              comptabilisation</label>
            <div class="col-xs-12 col-md-9 px-0" *ngIf="canBeModified">
              <ng-multiselect-dropdown name="nonERPComptabilityGroup"
                class="multiselect-dropdown-compta"
                [(ngModel)]="nonErpGroupSelectedItem"
                [settings]="groupDropDownSettings"
                (onSelect)="onSelectGroup($event, workflowDetail.NonERPComptabilityGroup,'select')"
                (onDeSelect)="onSelectGroup($event, workflowDetail.NonERPComptabilityGroup,'deselect')"
                placeholder="Sélectionner" [disabled]="!canBeModified" [data]="nonErpGroups" required>
              </ng-multiselect-dropdown>
            </div>
            <div class="col-xs-12 col-md-9 px-0 item-detail-value" *ngIf="!canBeModified">
              {{workflowDetail.NonERPComptabilityGroup.Name}}
            </div>
          </div>

        </div>
      </div>
    </section>

    <br>
    <div class="row justify-content-end">
      <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()" style="margin-right: 20px;">
        <mat-icon>cancel</mat-icon>
        <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
      </button>

      <button mat-stroked-button class="currentBtnColor" matTooltip="Modifier" (click)="onSave()" [disabled]="(workflowDetail.WorkflowStages.length == 0) || !isValidationStageValid || !workflowForm.form.dirty || workflowForm.form.invalid || (!canBeModified && !workflowDetail.CanBeDisabled)">
        <mat-icon>save</mat-icon>
        <span class="long-btn-span" fxHide fxShow.gt-md>Enregistrer</span>
      </button>
    </div>

    <ng-template #displayDetail>
      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Nom</label>
        <div class="col-xs-12 col-md-9 px-0 item-detail-value">
          {{workflowDetail.Name}}
        </div>
      </div>
      <div class="form-group-container form-group mx-0 row" *ngIf="displayComptabilitySection">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Groupe en charge de la comptabilisation</label>
        <div class="col-xs-12 col-md-9 px-0 item-detail-value">
          {{workflowDetail.NonERPComptabilityGroup.Name}}
        </div>
      </div>
      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Groupe opérationnel</label>
        <div class="col-xs-12 col-md-9 px-0 item-detail-value">
          {{workflowDetail.OperationalGroup?.Name}}
        </div>
      </div>

      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Date de création</label>
        <div class="col-xs-12 col-md-9 px-0 item-detail-value">
          {{workflowDetail.CreationDate | date:'dd/MM/yyyy'}}
        </div>
      </div>

      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Actif</label>
        <div class="col-xs-12 col-md-9 px-0" *ngIf="this.isAdministrator">
          <mat-slide-toggle name="isActive" [(ngModel)]="workflowDetail.IsActive"
            [disabled]="!workflowDetail.CanBeDisabled && this.isAdministrator" tooltip="Activer / désactiver le flux de validation">
          </mat-slide-toggle>
        </div>
        <div class="col-xs-12 col-md-9 px-0" *ngIf="!this.isAdministrator">
          <mat-slide-toggle name="isActive" [(ngModel)]="workflowDetail.IsActive"
            [disabled]="true" tooltip="Activer / désactiver le flux de validation">
          </mat-slide-toggle>
        </div>
      </div>
    </ng-template>

    <ng-template #editDetail>

      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label" for="name">Nom</label>
        <div class="col-xs-12 col-md-9 px-0">
          <input type="text" name="name" autocomplete="off" [disabled]="!canBeModified"
            [(ngModel)]="workflowDetail.Name" required>
        </div>
      </div>

      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label" for="operationalGroup">Groupe
          opérationnel</label>
        <div class="col-xs-12 col-md-9 px-0">
          <ng-multiselect-dropdown name="operationalGroup" class="multiselect-dropdown-ope" [(ngModel)]="operationalGroupSelectedItem"
            [settings]="groupDropDownSettings" placeholder="Sélectionner" [disabled]="!canBeModified"
            [data]="operationalGroups" (onSelect)="onSelectGroup($event, workflowDetail.OperationalGroup,'select')"
            (onDeSelect)="onSelectGroup($event, workflowDetail.OperationalGroup,'deselect')" required>
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="form-group-container form-group mx-0 row">
        <label class="col-xs-12 col-md-3 my-auto pl-0 item-detail-label">Actif</label>
        <div class="col-xs-12 col-md-9 px-0">
          <mat-slide-toggle name="isActive" [(ngModel)]="workflowDetail.IsActive" [disabled]="!canBeModified && this.isAdministrator"
            tooltip="Activer / désactiver le flux de validation">
          </mat-slide-toggle>
        </div>
      </div>

    </ng-template>
  </form>
</div>